<template>
    <div>
        <el-card class="box-card" style="background-color:#E9EEF3;">
            <div slot="header" class="clearfix">
                <span style="margin-left: 50% ;font-size: xx-large"><h3 align="center">测试参加人知情同意书</h3></span>
<!--                <img src="../assets/image/Notification/1.png" style="margin-left: 28%"/><img src="../assets/image/Notification/2.png" style="text-align: center"/>-->

            </div>
            <div class="text item">
<!--              <p style="text-indent:2em;text-align: center">博士研究项目：成人学习者在线预测加工能力的发展</p>-->
<!--              <p style="text-indent:2em;">-->
<!--                项目由英国约克大学教育系博士研究生盘峻岚执行。本在线测试（中国成人学习者的认知个体差异）-->
<!--                是博士项目“成人学习者在线预测加工能力的发展”（2019年起）的一部分。中文知情同意书供测试参加者使用，-->
<!--                与教育系伦理审查通过的英文版内容一致。-->
<!--              </p>-->
                <h2>尊敬的测试参加人：</h2>
                <p>您好！</p>
              <p style="  text-indent:2em;">欢迎参加语言学能在线测试。
              在您同意参加测试前，请仔细阅读以下信息，如果您有任何疑问或需要了解更多信息，请联系
                <a href="mailto:tall-webtest@foxmail.com.">tall-webtest@foxmail.com</a>。
              </p>
              <hr style="color: black" width="100%" SIZE=3>
<!--              <p style="  text-indent:2em;">我叫盘峻岚，是英国约克大学教育系的博士研究生，正进行一项关于“成人学习者在线预测加工能力的发展”的研究项目。-->
<!--                  很荣幸地邀请您参加这个项目中的认知个体差异在线测试。在您同意参加测试前，请仔细阅读以下信息，-->
<!--                  如果您有任何疑问或需要了解更多信息，请联系我。</p>-->
                <h2><strong>本研究的目的是什么?</strong></h2>
                <p style="text-indent:2em;">本研究旨在使用语言学能在线测试工具，收集反映学习者的学能个体差异数据进行相关研究。</p>
                <h2><strong>本研究对您意味着什么？</strong></h2>
                <p style="text-indent:2em;">由于我们将根据研究计划使用不同的方式测试学习者的差异，您有可能需要分1-2次参加测试，完成不同版本的测试题目。
                  测试完成后，我们可以提供一份您个人的语言学能报告，您可以通过组织您参加测试的老师索取。
               </p>
                <h2><strong>自愿参加原则</strong></h2>
                <p style="text-indent:2em;">本研究系自愿参加。如果您愿意参加，请确认知情同意书并下载保存。测试中您会有适度的紧张感。
                  如果您在测试过程中不想继续参加了，您可以选择退出，不需要解释理由。</p>
                <h2><strong>匿名与保密</strong></h2>
                <p style="text-indent:2em;">
                  您提供的数据（比如测试的分数）将编码保存。任何可以辨识您身份的信息都将与数据分开保存。您可以在数据收集的过程中放弃参加测试。
                  在数据收集完毕后的两周内，您也可以发邮件至 <a href="mailto:tall-webtest@foxmail.com.">tall-webtest@foxmail.com</a>
                  ,要求撤销您的数据。</p>
                <h2><strong>数据保存与使用</strong></h2>
                <p style="text-indent:2em;">
                  您的数据将加密保存。作为一个开放测试和数据库，您的数据将使用
                  <el-link type="primary" href="https://creativecommons.org/licenses/by-nc-sa/4.0/" target="_blank">创作共用许可证：
                  署名-非商业性-相同方式共享（CC BY-NC-SA）</el-link>
                  ,免费提供给任何人用于研究目的，
                  但在关于研究的演讲、上线、研究报告、项目总结中，您的数据都将匿名，您的数据也无法识别您的身份。
                  <b>如果您不同意我们用这种方式使用您的数据，请您不要参加本测试。</b><br/>
                </p>
              <p style="text-indent:2em;">
                  我们将按照《通用数据保护条例》(GDPR)第6(1)(e)条规定进行个人数据保护：处理数据是从事以公益为目的的工作的需要。<br/>
                  特殊目录数据的处理根据第9(2)(j)条：处理数据是公益性的存档，或科学和历史研究目的，或统计目的的需要。<br/>
                  关于《通用数据保护条例》(GDPR)的信息，请登陆查询：<el-link type="primary" href="https://www.york.ac.uk/education/research/gdpr_information/" target="_blank">https://www.york.ac.uk/education/research/gdpr_information/</el-link></p>
                <h2><strong>问题或顾虑</strong></h2>
                <p style="text-indent:2em;">
                  如果您有任何关于测试信息和数据处理的问题或顾虑，敬请联系：
                  <a href="mailto:tall-webtest@foxmail.com.">tall-webtest@foxmail.com</a>,
                  或者联系伦理委员会主席：<a href="mailto:education-research-admin@york.ac.uk.">education-research-admin@york.ac.uk</a>。
                  如果您对他们提供的信息还有不满意之处，
                  敬请联系约克大学数据保护官员：<a href="mailto:dataprotection@york.ac.uk.">dataprotection@york.ac.uk</a>。<br/>
                  我们真诚地希望您能同意参加本测试。如果您愿意参加，请完成所附的知情同意书，点击“确认”发回。<br/>
                </p>
              <p style="text-indent:2em;">
                非常感谢您对语言学能在线测试研究的支持！
                <p style="text-indent:2em;">
                  此致 <br/>
              敬礼
                </p>
                <p style="text-indent:2em;">
                  TALL项目团队
                </p>
              <br/>
              <br/>
              <p style="text-indent:2em;">
              请点击“继续”确认您已经理解了上述信息，并同意参加本次测试。
              </p>

            </div>
        </el-card>
        <el-button style="margin-left:48%;font-size:large" type="text" @click="agree()">同意并继续</el-button>
    </div>
</template>
<script>
    import GLOBAL from '../plugins/global_variable'
    export default {
        name: "Notification",
        methods: {
            agree() {
                this.$router.push('/InformConsent');



            },


        },

        created() {//生命周期函数

            document.body.style.backgroundColor="#CCCCCC";





        },
        mounted() {
            history.pushState(null, null, document.URL);
            window.addEventListener('popstate', function () {
                history.pushState(null, null, document.URL);
            });

        }
    }
</script >

<style scoped>
    .text {
        font-size: 18px;

    }

    .item {
        margin-bottom: 18px;

    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }

    .box-card {
        width: 100%;


    }
</style>